export default class Meta {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        metaRetrieve(id: ${id}) {
          id
          name
          obj
          type
          percentage
          meta
          incentive         
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );   

    return response.data.data.metaRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        metaList {
          results {
            id
            name
            obj
            type
            percentage
            meta
            incentive                     
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.metaList.results.length; i++)
    {
      switch(response.data.data.metaList.results[i].type) {
        case "D":
           response.data.data.metaList.results[i].type = "DESCARGA";
        break;
        case "C":
           response.data.data.metaList.results[i].type = "CIERRE DE DEAL";
        break;   
        case "R":
           response.data.data.metaList.results[i].type = "REGISTRO";
        break;
        case "V":
           response.data.data.metaList.results[i].type = "VENTA DE CUPONERA";
        break;                      
      }
    }

    return response.data.data.metaList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteMeta(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteMeta.ok;
  }

}